import * as types from './mutation-types'
import util from '@/util'

export default {
  [types.SET_DADOS_FORMULARIO_ESCRITORIO] (state, formulario) {
    state.formulario = formulario
  },
  [types.SET_DADOS_RETORNO_ESCRITORIO] (state, dadosRetorno) {
    state.dadosRetorno = dadosRetorno
  },
  [types.SET_FLAGS_DE_CONTROLE] (state, flagsDeControle) {
    state.flagsDeControle = flagsDeControle
  },
  [types.SET_DADOS_RETORNO_CADASTRO] (state, dadosRetornoDoCadastro) {
    state.dadosRetorno.sucesso = dadosRetornoDoCadastro.sucesso
    state.dadosRetorno.listaDeErros = dadosRetornoDoCadastro.listaDeErros
    state.dadosRetorno.mensagem = dadosRetornoDoCadastro.mensagem
  },
  [types.SET_DADOS_FORMULARIO_INFORMACOES] (state, formulario) {
    state.formulario.tipo = formulario.tipo ?? 1
    state.formulario.id = formulario.id
    state.formulario.id_contexto = formulario.id_contexto
    state.formulario.informacoes.observacoes = formulario.observacoes
    state.formulario.informacoes.status = formulario.status
    state.formulario.informacoes.data_cadastro = util.formatarData(formulario.data_cadastro, 'DD/MM/YYYY HH:mm:ss')
    state.formulario.informacoes.data_inativacao = util.formatarData(formulario.data_inativacao, 'DD/MM/YYYY HH:mm:ss')
    state.formulario.informacoes.office = formulario.office
    state.formulario.informacoes.codigo_empresa = formulario.codigo_empresa
    state.formulario.informacoes.endereco_logotipo = formulario.endereco_logotipo
  },
  [types.SET_DADOS_FORMULARIO_INFORMACOES_PESSOAIS] (state, formulario) {
    if (formulario.tipo === 1) {
      state.formulario.informacoes.pessoais.nome = formulario.nome
      state.formulario.informacoes.pessoais.nome_fantasia = formulario.nome_fantasia
      state.formulario.informacoes.pessoais.cpf_cnpj = formulario.cpf_cnpj
      state.formulario.informacoes.pessoais.rg = formulario.rg
      state.formulario.informacoes.pessoais.data_nascimento = formulario.data_nascimento
    }
  },
  [types.SET_DADOS_FORMULARIO_INFORMACOES_EMPRESARIAIS] (state, formulario) {
    if (formulario.tipo === 2) {
      state.formulario.informacoes.empresariais.nome = formulario.nome
      state.formulario.informacoes.empresariais.nome_fantasia = formulario.nome_fantasia
      state.formulario.informacoes.empresariais.cpf_cnpj = formulario.cpf_cnpj
      state.formulario.informacoes.empresariais.inscricao_estadual = formulario.inscricao_estadual
      state.formulario.informacoes.empresariais.inscricao_municipal = formulario.inscricao_municipal
      // const idRepresentante = formulario.representante_legal
      // const representanteLegal = state.listaUsuariosRepresentanteLegal.find(representante => representante.id === idRepresentante)
      // state.formulario.informacoes.empresariais.representante_legal = { code: representanteLegal?.id, label: representanteLegal?.nome }
      state.formulario.informacoes.empresariais.opt_simples = formulario.opt_simples
    }
  },
  [types.SET_DADOS_FORMULARIO_ENDERECO] (state, formulario) {
    state.formulario.endereco.cep = formulario.cep
    state.formulario.endereco.endereco = formulario.endereco
    state.formulario.endereco.numero = formulario.numero
    state.formulario.endereco.complemento = formulario.complemento
    state.formulario.endereco.bairro = formulario.bairro
    state.formulario.endereco.cidade = formulario.cidade
    const idUnidadeFederativa = formulario.uf
    const uf = state.listaUnidadesFederativas.find(unidadeFederativa => unidadeFederativa.id === idUnidadeFederativa)
    state.formulario.endereco.uf = { code: uf?.id, label: uf?.nome }
  },
  [types.SET_DADOS_FORMULARIO_CONTATO] (state, formulario) {
    state.formulario.contato.email = formulario.email
    state.formulario.contato.celular = formulario.celular
    state.formulario.contato.fone = formulario.fone
  },
  [types.SET_LISTA_USUARIOS_REPRESENTANTE_LEGAL] (state, listaUnidadesDisponiveis) {
    state.listaUnidadesDisponiveis = listaUnidadesDisponiveis
  },
  [types.SET_LISTA_USUARIOS_REPRESENTANTE_LEGAL] (state, listaUsuariosRepresentanteLegal) {
    state.listaUsuariosRepresentanteLegal = listaUsuariosRepresentanteLegal
  },
  [types.SET_LISTA_UNIDADES_FEDERATIVAS] (state, listaUnidadesFederativas) {
    state.listaUnidadesFederativas = listaUnidadesFederativas
  },
  [types.SET_GESTAO_PRODUTOS_HABILITADO] (state, gestaoProdutosHabilitado) {
    state.gestaoProdutosHabilitado = gestaoProdutosHabilitado
  }
}
